// client/src/features/auth/LoginDialog.jsx

import React from 'react';

import {
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';

import {
  CloseOutlined,
} from '@mui/icons-material';

import LoginForm
  from './LoginForm';


const LoginDialog = ({
  open,
  onClose,
  onSuccess,
}) => {
  return (
    <Dialog
      open={
        open
      }

      onClose={
        onClose
      }

      maxWidth={
        false
      }

      slotProps={{
        paper: {
          sx: {
            width:
              {
                xs:
                  'calc(100% - 32px)',

                sm:
                  '400px',
              },

            maxWidth:
              '400px',

            m:
              0,

            p:
              0,

            backgroundColor:
              'transparent',

            backgroundImage:
              'none',

            boxShadow:
              'none',

            overflow:
              'visible',

            border:
              'none',
          },
        },
      }}
    >
      <DialogContent
        sx={{
          position:
            'relative',

          p:
            '0 !important',

          m:
            0,

          overflow:
            'visible',

          backgroundColor:
            'transparent',
        }}
      >
        <IconButton
          onClick={
            onClose
          }

          aria-label="Close login"

          sx={{
            position:
              'absolute',

            right:
              12,

            top:
              12,

            zIndex:
              10,

            color:
              'text.primary',
          }}
        >
          <CloseOutlined />
        </IconButton>


        <LoginForm
          passwordLoginDefaultOpen={
            false
          }

          onSuccess={
            onSuccess
          }
        />
      </DialogContent>
    </Dialog>
  );
};


export default LoginDialog;